<!-- Accessible Food Spot dialog with proper keyboard navigation -->
<div class="wrapper-foodspot" role="dialog" aria-labelledby="foodspot-title" aria-describedby="foodspot-description">
	<!-- Left informational panel -->
	<section class="left" role="complementary" aria-label="Food Spot information">
		<h3 id="foodspot-title">{{ 'foodspot_dialog.title' | translate }}</h3>
		<p id="foodspot-description">
			{{ 'foodspot_dialog.subtitle' | translate }}
		</p>
	</section>

	<!-- Right form panel -->
	<section class="right" role="main">
		<!-- Header with close button -->
		<header class="header-section">
			<h2 id="foodspot-form-title">{{ 'preorder_type.foodspot' | translate }}</h2>
			<button class="close-button" (click)="close()" aria-label="Close dialog" tabindex="0">
				<ion-icon src="../../../assets/dean_and_david/cross_black.svg" aria-hidden="true"></ion-icon>
				<span class="visually-hidden">Close</span>
			</button>
		</header>

		<!-- Form section -->
		<div class="input-section">
			<h3 class="visually-hidden">{{ 'preorder_type.foodspot' | translate }}</h3>

			<p>{{ 'foodspot_dialog.about_description' | translate }}</p>

			<!-- Code entry form -->
			<form (ngSubmit)="validate()" class="code-form">
				<div class="input-block">
					<label for="foodspot-code" class="visually-hidden">Enter Food Spot code</label>
					<ion-input
						id="foodspot-code"
						class="no-underline code-input"
						placeholder="Enter code"
						type="text"
						[class.error]="inputControl.hasError('notExist')"
						[formControl]="inputControl"
						[attr.aria-describedby]="inputControl.hasError('notExist') ? 'error-message' : null"
						[attr.aria-invalid]="inputControl.hasError('notExist') ? 'true' : 'false'"
						aria-label="Food Spot code"
						tabindex="0"
					>
					</ion-input>

					<ion-button
						type="submit"
						class="submit-button"
						(click)="validate()"
						(keydown.enter)="validate()"
						[disabled]="!this.inputControl.value || loading"
						[attr.aria-label]="loading ? 'Validating code...' : 'Submit Food Spot code'"
						tabindex="0"
					>
						<span *ngIf="!loading" class="text-body">{{ 'foodspot_dialog.submit' | translate }}</span>
						<ion-spinner *ngIf="loading" name="crescent" aria-hidden="true"></ion-spinner>
						<span *ngIf="loading" class="visually-hidden">Validating code...</span>
					</ion-button>
				</div>

				<!-- Error message -->
				<div class="error-message" *ngIf="inputControl.hasError('notExist')" id="error-message" role="alert" aria-live="polite">
					<span>{{ 'foodspot_dialog.error' | translate }}</span>
				</div>
			</form>
		</div>

		<!-- Empty spacer div for layout -->
		<div class="spacer" aria-hidden="true"></div>
	</section>
</div>
